export const ConvertionHelpers = {
    DateToISODateOnly: (d: Date | null): string | null => {
        if (d) {
            return (d.getFullYear() + "-" + ((d.getMonth() < 9) ? "0" : "") + (d.getMonth() + 1) + "-" + (d.getDate() < 10 ? "0" : "") + d.getDate());
        }
        return null;
    },
};